import { ONE_KIBIBYTE, ONE_KILOBYTE } from '@lucidlink/uicore';
import { RATE_LIMIT_UNITS } from '#constants';
const units = ['MiB', 'GiB', 'TiB'];
// Custom logic to replicate 2.0 behavior
export const convertUnitToInt = ({ unit, value, }) => {
    const isFloat = value % 1 !== 0;
    if (isFloat) {
        return convertUnitToInt({
            value: value * Math.pow(ONE_KIBIBYTE, 1),
            unit: units[units.indexOf(unit) - 1] || units[0],
        });
    }
    return { value, unit };
};
export const sizeToValueAndUnit = (size) => {
    const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(ONE_KIBIBYTE));
    const value = Number(size / Math.pow(ONE_KIBIBYTE, i)) * 1;
    const unit = units[i] || units[0];
    return {
        value,
        unit,
    };
};
export const convertToMiB = (size, unit = 'MiB') => {
    const pow = units.indexOf(unit);
    return size * Math.pow(ONE_KIBIBYTE, pow);
};
export const convertRateLimitToBytesPerSecond = (rate, unit = 'KB/s') => {
    const pow = RATE_LIMIT_UNITS.indexOf(unit) + 1;
    return rate * Math.pow(ONE_KILOBYTE, pow);
};
